import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { get } from "../../../../utils/api";
import MultiColumns from "../MultiColumns";

import { companyId } from "../../../../utils/companyId";

const Community = ({ isEditing }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/social/community_engagement/${companyId}`);
        // Update state only if data is available
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const questionary = [
    {
      key: "csrSpending.value",
      key2: "csrSpending.unit",
      question: "Corporate Social Responsibility (CSR) Spending",
      gridSize: { xs: 12 },
    },
    { mainheading: "Community Investment Programs", gridSize: { xs: 12 } },
    {
      key: "communityInvestmentPrograms",
      subkey: "number",
      question: "Number",
    },
    { key: "communityInvestmentPrograms", subkey: "scope", question: "Scope" },
    { mainheading: "Impact of Community Programs", gridSize: { xs: 12 } },
    {
      key: "impactOfCommunityPrograms",
      subkey: "beneficiaries",
      question: "Beneficiaries",
    },

    {
      key: "payEquity.malePayGap",
      key: "impactOfCommunityPrograms",
      subkey: "outcomes",
      question: "Outcomes",
    },
    { mainheading: "Volunteer Hours", gridSize: { xs: 12 } },
    { key: "volunteerHours", subkey: "total_hours", question: "Total Hours" },
    {
      key: "volunteerHours",
      subkey: "total_volunteers",
      question: "Volunteer Hours",
    },
  ];

  return (
    <>
      <MultiColumns
        title="COMMUNITY ENGAGEMENT"
        url={`/social/community`}
        questionary={questionary}
        columns={2}
        data={data}
        isEditing={isEditing}
      />
    </>
  );
};

export default Community;
